module.exports = __webpack_public_path__ + "img/partC2.d4b758a5.png";